export default function PageHeader({ title, subtitle, icon: Icon, actions }) {
  return (
    <div className="mb-5 sm:mb-6 flex items-center justify-between gap-3 sm:gap-4 flex-wrap">
      <div className="flex items-center gap-3 sm:gap-4 min-w-0">
        {Icon && (
          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-teal-700 text-white flex items-center justify-center shadow-md shadow-teal-700/20 shrink-0">
            <Icon size={20} />
          </div>
        )}
        <div className="min-w-0">
          <h1 className="font-cairo text-xl sm:text-2xl lg:text-3xl font-extrabold text-slate-900 tracking-tight leading-tight" data-testid="page-title">{title}</h1>
          {subtitle && <p className="text-xs sm:text-sm text-slate-500 mt-0.5 sm:mt-1">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
